module.exports = __webpack_public_path__ + "img/process_medium.21ddc1ce.jpg";